import { bindActionCreators, PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

declare global {
  type listValType = {
    filterList?: any;
    applyFilterList?: any;
    typeSearchArray?: any[];
    sortSearchData?: string;
    sortSearchIdx?: number;
    keywordSearchData?: string;
    searchContentsData?: string;
    searchStartDate?: string;
    searchEndDate?: string;
    currentPageNumber?: number;
    myExecuteString?: string;
  };
}
const initialState: listValType = {
  filterList: {
    typeFilter: {
      title: "공지 유형",
      data: [
        { type: "일반공지", checked: false },
        { type: "마네킨 착장", checked: false },
        { type: "매장연출", checked: false },
        { type: "영상 ", checked: false },
        { type: "비주얼", checked: false },
        { type: "기타 ", checked: false },
      ],
    },
    dateFilter: {
      title: "기간",
      data: [
        { type: "1개월", checked: false },
        { type: "3개월", checked: false },
        { type: "6개월", checked: false },
        { type: "12개월", checked: false },
        { type: "기간선택", checked: false },
      ],
    },
  },
  applyFilterList: {},
  typeSearchArray: [],
  keywordSearchData: "",
  sortSearchData: "최신순",
  sortSearchIdx: 0,
  searchContentsData: "",
  searchStartDate: "",
  searchEndDate: "",
  currentPageNumber: 1,
  myExecuteString: "",
};

const listSlice = createSlice({
  name: "noticeList",
  initialState,
  reducers: {
    // 기본데이터 세팅
    setListDataInit: (state: listValType) => ({
      ...state,
      ...{
        filterList: initialState.filterList,
        typeSearchArray: initialState.typeSearchArray,
      },
    }),
    // 필터
    setListData: (state: listValType, action: PayloadAction<listValType>) => ({
      ...state,
      ...{
        filterList: action.payload.filterList ?? state.filterList,
        applyFilterList: action.payload.applyFilterList ?? state.applyFilterList,
        typeSearchArray: action.payload.typeSearchArray ?? state.typeSearchArray,
        keywordSearchData: action.payload.keywordSearchData ?? state.keywordSearchData,
        sortSearchData: action.payload.sortSearchData ?? state.sortSearchData,
        sortSearchIdx: action.payload.sortSearchIdx ?? state.sortSearchIdx,
        searchContentsData: action.payload.searchContentsData ?? state.searchContentsData,
        searchStartDate: action.payload.searchStartDate ?? state.searchStartDate,
        searchEndDate: action.payload.searchEndDate ?? state.searchEndDate,
        currentPageNumber: action.payload.currentPageNumber ?? state.currentPageNumber,
        myExecuteString: action.payload.myExecuteString ?? state.myExecuteString,
      },
    }),
    deleteTypeSearch: (state: listValType, action: PayloadAction<any>) => {
      state.typeSearchArray = state.typeSearchArray?.filter((type) => type !== action.payload);
    },
    setRecentKeyword: (state, action: PayloadAction<string>) => {
      state.searchContentsData = action.payload;
    },
  },
});

export const { setListDataInit, setListData, deleteTypeSearch, setRecentKeyword } = listSlice.actions;

export default listSlice.reducer;
